<template>
  <div id="app">
    <fullscreen />
    <div class="darken">
      <navbar />
      <spacer />
      <router-view/>
      <footbar v-if="$router.currentRoute.name !== 'Credits'" />
    </div>
  </div>
</template>

<script>
import navbar from './components/navbar';
import fullscreen from './components/fullscreen';
import footbar from './components/footbar';
export default {
  name: 'app',
  components: {
    navbar,
    fullscreen,
    footbar
  },
  mounted() {
    console.log(this.$router.currentRoute)
  }
}
</script>

<style>
.relative {
  position: relative;
}

.align-left {
  text-align: left;
}

.text-outline {
  text-shadow: 1px 0px 8px black, -1px 0px 8px black, 0px 1px 8px black, 0px -1px 8px black;
}

@media (orientation: landscape) and (min-width: 1281px) {
  html {
    font-size: 1vmax;
    background-color: rgb(34, 34, 34);
    background-attachment: fixed;
    background-position: center;
    background-size: cover;
    background-image: url('./assets/background/html-background-texture.jpg');
  }
  .mobile {
    display: none;
  }
  body {
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
  }

  h1, h2, h3, h4, h5 {
    font-family: 'Jura', sans-serif;
    font-weight: 700;
  }
  h1 {
    font-size: 2em;
  }

  span, p {
    font-size: 1.2em;
  }

  button.big {
    font-size: 2em;
  }
  .light-block {
    border-radius: 0.25em;
    border-color: rgb(6, 34, 74);
    border-style:solid;
    border-width:1px;
    color: rgb(6, 34, 74);
    padding: 1em 3em 3em 3em;
    background-color:rgba(255,255,255,0.8);
    margin: 20px;
  }
}

@media (orientation: portrait), (max-width: 1280px) {
  html {
    font-size: 3vmax;
    background-attachment: fixed;
    background-position: center;
    background-size: cover;
    background-image: url('./assets/background/html-background-texture.jpg');
  }
  .pc {
    display: none;
  }
  button.big {
    font-size: 1.2em;
  }
  .light-block {
    border-color: rgb(6, 34, 74);
    color: rgb(6, 34, 74);
    background-color:rgba(255,255,255,0.8);
    background-clip: border-box;
    margin: 1em -8px !important;
    padding: 1em 1%;
  }
}

button.round-big {
  border-radius: 50%;
  height: 2em;
  width: 2em;
  font-size: 2em;
  font-weight:bolder;
  font-family:"calibri light";
  color:rgb(34, 34, 34);
}
button.round-medium {
  border-radius: 50%;
  height: 2em;
  width: 2em;
}
button.round-small {
  border-radius: 50%;
  height: 1em;
  width: 1em;
}

button {
  border: 0;
  color: white;
  background-color:rgb(6, 34, 74);
  margin: auto;
  border-radius: 0.2em;
  font-weight: 700;
}

button.big {
  width: auto;
  padding: 0.25em;
  font-weight:bolder;
}

button:hover {
  background-color:#0069d9;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #c3c7ca;
}
</style>
